import React from 'react';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import SignUpForm from './components/SignUpForm';
import Footer from './components/Footer';
import TheSystem from './components/TheSystem';
import { Analytics } from '@vercel/analytics/react';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <div className='App'>
      <Navbar />
      <Hero />
      <TheSystem />

      <HowItWorks />
      <SignUpForm />
      <Footer />
      <Analytics />
      <ToastContainer />
    </div>
  );
}

export default App;
